import * as React from 'react';

import { Image } from '../foundation/Assets';

export interface IArrowDownProps {
    onArrowDown: (value: boolean) => void;
}
export class ArrowDown extends React.Component<IArrowDownProps> {
    constructor(props: IArrowDownProps) {
        super(props);
        this.onArrowDown = this.onArrowDown.bind(this);
        this.startScroll = this.startScroll.bind(this);
        this.stopScroll = this.stopScroll.bind(this);
    }
    buttonDelay: NodeJS.Timeout;
    buttonPressInterval: NodeJS.Timeout;
    
    private startScroll() {
        this.onArrowDown();
        this.buttonDelay = setTimeout(() => {
            this.buttonPressInterval = setInterval(() => {
                this.onArrowDown();
            }, 64);
        }, 590);
    }

    private stopScroll = () => {
        clearInterval(this.buttonPressInterval);
        clearTimeout(this.buttonDelay);
    }

    private onArrowDown() {
        this.props.onArrowDown(true);
    }

    render() {
        return (
            <div>
                <div onMouseDown={this.startScroll} onMouseUp={this.stopScroll} onMouseLeave={this.stopScroll} onTouchStart={this.startScroll} onTouchEnd={this.stopScroll} className="arrow down"> <Image.arrownext /> </div>
            </div>
        )
    }
}